import React, { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Box } from '@material-ui/core'
import { SidebarContent } from './Content'
import { CSSProperties } from '@material-ui/core/styles/withStyles'
import RootStoreContext from '../../storage/RootStore'
import { constants } from '../../Constants'
import { Logo } from './Logo'


interface SidebarProps { }

export const Sidebar: React.FC<SidebarProps> = observer(() => {

     const { dataset, dimensions } = useContext(RootStoreContext)

     const style: CSSProperties = {
          background: constants.SIDEBAR.COLOR_BG,
          height: '100vh',
          width: dimensions.WIDTH_SIDEBAR,
          padding: '0',
          overflowY: 'auto'
     }


     return (
          <>
               <Box style={style}>
                    {dataset.current ? (
                         <Box style={{ padding: '1em 1em' }}>
                              <SidebarContent dataset={dataset.current} />
                         </Box>
                    ) : null}
                    <Logo />
               </Box>
          </>
     )
})
